"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const locale = {
  message_success: 'Successful',
  message_info: 'Info',
  message_warning: 'Warning',
  message_error: 'Error'
};
var _default = exports.default = locale;